import { Button } from '@welbe/design-system';
import { Modal, Spinner } from '@welbe/web-design-system';
import RejectCandidate from 'App/assets/img/reject_candidate.svg?url';
import {
	Container,
	ContainerSpinner,
	Content,
	ContentButton,
	ContentTitle,
	Icon,
} from './ModalInactiveEmployee.styles';

type ModalInactiveEmployeeProps = {
	selectedEmployees: any[];
	isLoading: boolean;
	handleClose: () => void;
	handleInactiveEmployee: () => void;
};

export const ModalInactiveEmployee = ({
	selectedEmployees,
	isLoading,
	handleClose,
	handleInactiveEmployee,
}: ModalInactiveEmployeeProps): JSX.Element => {
	return (
		<>
			<Modal
				open
				height="280px"
				zIndex={1100}
				headerIcon={<Icon src={RejectCandidate} />}
				preventBackdropClose
				closeButton
				onClose={handleClose}
			>
				<Container>
					<ContentTitle>Baja colaboradores</ContentTitle>
					{isLoading ? (
						<ContainerSpinner>
							<Spinner size="4vh" />
						</ContainerSpinner>
					) : (
						<>
							<Content>
								{selectedEmployees && selectedEmployees.length > 1
									? `¿Estás seguro que deseas dar de baja estos ${selectedEmployees.length} colaboradores?`
									: `¿Estás seguro que deseas dar de baja a ${selectedEmployees[0].name}?`}
							</Content>
							<ContentButton>
								<Button
									id="cancelInactiveEmployee"
									key="1"
									type="button"
									onClick={handleClose}
									variant="outline"
								>
									Regresar
								</Button>
								<Button
									id="confirmInactiveEmployee"
									key="2"
									type="button"
									onClick={async () => {
										await handleInactiveEmployee();
										handleClose();
									}}
								>
									Confirmar
								</Button>
							</ContentButton>
						</>
					)}
				</Container>
			</Modal>
		</>
	);
};
